// extracted by mini-css-extract-plugin
export default {"item":"BusinessHourDisplay_item__DQxlK","group":"BusinessHourDisplay_group__TYHZU","day-name":"BusinessHourDisplay_day-name__LoWB1","hours":"BusinessHourDisplay_hours__ry8Pl"};